<template>
  <div>
    <van-search
        placeholder="请输入关键词"
        v-model="keywords"
        shape="round"
        @search="onSearch"
    >
    </van-search>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多数据了"
          :error.sync="error"
          :immediate-check="false"
          error-text="请求失败，点击重新加载"
      >
        <van-card v-for="item in tableData" :key="item.sysGuid"
                  @click="goDetail(item)" class="card-content"
        >
          <div slot="title" class="title-content" >
            <div class="title-font">{{item.busiTypeName}} </div>
            <div>
              <van-tag type="danger"   v-if="item.status === '2'"> {{item.statusName}}</van-tag>
              <van-tag type="warning"  v-if="item.status === '1'"> {{item.statusName}}</van-tag>
              <van-tag type="success"  v-if="item.status === '0'"> {{item.statusName}}</van-tag>
              <van-icon name="arrow" />
            </div>
          </div>
          <div slot="bottom">
            <div style="line-height: 20px;display: flex;justify-content: space-between;">
              <div>提交时间</div>
              <div>{{item.reqTime}}</div>
            </div>
          </div>
        </van-card>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import {queryMyBusiPrebookList} from '@/api/maintainFund/maintainFund'
import { Tag} from "vant";
import { Icon } from 'vant'
export default {
  name: "MyAppointBusiness",
  components:{
    VanTag: Tag,
    VanIcon: Icon
  },
  data(){
    return {
      keywords: '',
      //下拉刷新
      isLoading: false,
      //滑动底部加载状态
      loading: false,
      //数据是否全部加载完毕
      finished: false,
      tableData:[],
      error: false,
    }
  },
  created() {
    this.fetchData();
  },
  methods:{
    fetchData(){
      queryMyBusiPrebookList({
        keywords: this.keywords
      }).then(res=>{
        this.tableData = res.data
        console.log(this.tableData)
      })
    },
    onRefresh(){

    },
    goDetail(item){
      this.$router.push({
        path: '/maintainFund/businessProcessDetail',
        query: {
          detailInfo: item
        }
      })
    },
    onSearch(value){
      this.keywords = value;
      this.$nextTick(()=>{
        this.fetchData()
      })
    }
  }
}
</script>

<style scoped>
.title-content {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  padding: 5px 10px;
}
.title-font {
  font-size: 15px;
  font-weight: bold;
}

.card-content{
  border-radius: 20px;
}

</style>